module.exports = __webpack_public_path__ + "static/media/cq_nuovo_appuntamento_blu.0d6bf666.svg";